import { render, staticRenderFns } from "./ShippingLabelDialog.vue?vue&type=template&id=30a30534&scoped=true"
import script from "./ShippingLabelDialog.vue?vue&type=script&lang=ts"
export * from "./ShippingLabelDialog.vue?vue&type=script&lang=ts"
import style0 from "./ShippingLabelDialog.vue?vue&type=style&index=0&id=30a30534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a30534",
  null
  
)

export default component.exports